import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFaceIdFace: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="face-id-face"><path d="M5.75 17.5C9.9491 21.1667 14.0509 21.1667 18.25 17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 5.75V12.25C12.75 13.3546 11.8546 14.25 10.75 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 4.75V8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 4.75V8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFaceIdFace;
